module.exports = __webpack_public_path__ + "media/buzzer_eat-in_radio.05486354.webm";